import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { CustomDeviceDetectorService } from '../../services/CustomDeviceDetectorService';

@Component({
  selector: 'app-banner-photo',
  templateUrl: './banner-photo.component.html',
  styleUrls: ['./banner-photo.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BannerPhotoComponent implements OnInit {
  @Input() rendering: ComponentRendering;

  jssStylingService: JssStylingService;
  customDeviceDetectorService: CustomDeviceDetectorService
  dynamicClass: string;
  rightImage: boolean;
  injected: boolean;
  parallax: boolean;
  isMobile: boolean;
  image: IImage = {src:"",alt:" "};
  bgClassInjected: string;
  bgTextInjected: string;
  underSectionClass: string = "";

  imageParallaxBehind: IImage = {src:"",alt:" "};
  imageParallaxCenter: IImage = {src:"",alt:" "};
  imageParallaxFront: IImage = {src:"",alt:" "};

  wantBubbles: boolean;
  bubblesClass: string = " ";

  constructor(jssStylingService: JssStylingService, 
    customDeviceDetectorService: CustomDeviceDetectorService
  ) { 
    this.jssStylingService = jssStylingService;
    this.customDeviceDetectorService = customDeviceDetectorService
  }

  ngOnInit() {
    // remove this after implementation is done
    console.log('bannerPhoto component initialized with component data', this.rendering);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    var fields = (this.rendering.fields as any);
    this.injected = fields.ImagePosition['value'] == "Injected";
    this.parallax = fields.ImagePosition['value'] == "Parallax";
    this.wantBubbles = fields.WantBubbles['value'];
    if(!this.injected){
      this.rightImage = fields.ImagePosition['value'] == "Right";      
    }
    this.isMobile = this.customDeviceDetectorService.isMobile();
    if(this.wantBubbles && this.injected && !this.parallax){
      this.bubblesClass = "banner-photo-bubbles";
      if(this.isMobile){
        this.bubblesClass = "banner-photo-bubbles-mobile";
      }
    }
    if(fields.Image){
      this.image.src = fields.Image['value']['src'];
      this.image.alt = fields.Image['value']['alt'];
    }
    if(this.isMobile && fields.ImageMobile){
      this.image.src = fields.ImageMobile['value']['src'];
      this.image.alt = fields.ImageMobile['value']['alt'];
    }
    this.bgClassInjected = fields.BackgroundColor?.value == "Blue" ? "lg:eq-bg-blue-darkBlue" : fields.BackgroundColor?.value == "White" ? "lg:eq-bg-white" : "";
    this.bgTextInjected = fields.BackgroundColor?.value == "Blue" ? "eq-text-white" : fields.BackgroundColor?.value == "White" ? "eq-text-blue-darkBlue" : "";
    this.underSectionClass = this.injected && !this.parallax ? fields.BackgroundColor?.value == "Blue" ? 'eq-bg-blue-darkBlue lg:eq-bg-inherit' : 'eq-bg-white lg:eq-bg-inherit' : "";
    if(fields.ImageFront){
      this.imageParallaxFront.src = fields.ImageFront['value']['src'];
      this.imageParallaxFront.alt = fields.ImageFront['value']['alt'];
    }
    if(this.isMobile && fields.ImageFrontMobile){
      this.imageParallaxFront.src = fields.ImageFrontMobile['value']['src'];
      this.imageParallaxFront.alt = fields.ImageFrontMobile['value']['alt'];
    }
    
    if(fields.ImageCenter){
      this.imageParallaxCenter.src = fields.ImageCenter['value']['src'];
      this.imageParallaxCenter.alt = fields.ImageCenter['value']['alt'];
    }
    if(this.isMobile && fields.ImageCenterMobile){
      this.imageParallaxCenter.src = fields.ImageCenterMobile['value']['src'];
      this.imageParallaxCenter.alt = fields.ImageCenterMobile['value']['alt'];
    }

    if(fields.ImageBehind){
      this.imageParallaxBehind.src = fields.ImageBehind['value']['src'];
      this.imageParallaxBehind.alt = fields.ImageBehind['value']['alt'];
    }
    if(this.isMobile && fields.ImageBehindMobile){
      this.imageParallaxBehind.src = fields.ImageBehindMobile['value']['src'];
      this.imageParallaxBehind.alt = fields.ImageBehindMobile['value']['alt'];
    }
  }
}

interface IImage {
  src: string;
  alt: string;
}
